import { useState } from 'react';
import { addHuaweiServer, editHuaweiServer, huaweiLogin, huaweiStationList } from 'src/api/servers/huawei';
import { InputWithInnerLabel } from 'src/components/ui/inputFields/input-with-label';
import LoadingContainer from 'src/components/ui/loading/loading-container';
import StepperNav from '../stepperNav';
import { useDempStore } from 'src/context/stores';
import { useTranslation } from 'react-i18next'

const SetupHuawei = ({step,setStep, type, server, onClose, isEditServer}) => {
    const [ plantId ] = useDempStore((state) => [state.plantId]);
    const [connectionStatus, setConnectStatus] = useState({})
    const [isLoading, setIsLoading] = useState(false);
    const [stations, setStations] = useState([])
    const [userDetails, setUserDetails] = useState({})
    const { t } = useTranslation("settings");

    //handle submit
    //TODO: to refactor and simplify this function
    const handleLogin = async (e) => {
        e.preventDefault();
        // get data from form
        const formData = new FormData(e.target);

        // create object from form data
        const reqData = {};
        formData.forEach((value, key) => {
            reqData[key] = value;
        });

        setUserDetails(reqData)

        // post data to server
        const data = await huaweiLogin(reqData);

        //check if its success else show alert
        if(data?.success && data?.token){
            setConnectStatus(data);
            setTimeout(() => {
                setConnectStatus({})
            }, 3000);
            setStep(3);

            setIsLoading(true)
            const stationsList = await huaweiStationList(reqData?.username);
            
            
            if(stationsList?.success && stationsList?.data?.data){
                setStations(stationsList.data.data?.map((station)=>({
                    label: station.stationName,
                    value: station.stationCode
                })));
            }else{
                setStep(2)
                setConnectStatus({status: `${t('device_management.server_setup.connect_failed')}`, success: false})
            }
            setIsLoading(false) 
        }else{
            setConnectStatus(data);
            //clear state after 5 seconds
            setTimeout(() => {
                setConnectStatus({})
            }, 5000);
            
        };
        
    }
    // "username": "Sakayong_P",
    // "password": "Huawei@1234"

    const createNewServer = async (e) => {
        e.preventDefault();

        const formData = new FormData(e.target); 
        const reqData = {
            "name": formData.get("serverName"),
            "type": "huawei-cloud",
            "host": "https://sg5.fusionsolar.huawei.com/thirdData",
            "username": userDetails?.username,
            "password": userDetails?.password,
            "user_type": "old",
            "station_code": formData.get("stationCode")
          }
          

        try {
            let response;
            if(isEditServer){
                response = await editHuaweiServer(reqData,plantId)
            }else{
                response = await addHuaweiServer(reqData,plantId)
            }
        
            if(response?.data){
                
                setConnectStatus({status: isEditServer? `${t('device_management.server_setup.connect_updated')}` : `${t('device_management.server_setup.connect_created')}`, success: true})
                setTimeout(() => {
                    onClose()
                }, 1000);
            }else{
                setConnectStatus({status: response.error, success: false})
                setTimeout(() => {
                    setConnectStatus({})
                }, 10000);
            } 
        } catch (error) {
            setConnectStatus({status: error, success: false})
                setTimeout(() => {
                    setConnectStatus({})
                }, 5000);
        }
         
    }

    

    return ( 
        <>
            {step==2 && type=='huawei-cloud' &&
            <form onSubmit={handleLogin} className='relative'>
                
                <h2 className='text-sm font-semibold text-gray-700 '>2. {t('device_management.server_setup.huawei_login')} </h2>
                <div className="relative grid grid-cols-1 gap-4 pb-8 mt-3 md:grid-cols-2">
                    <InputWithInnerLabel 
                    label={`${t('device_management.server_setup.username')}`} name="username" placeholder="Vekin" required={true}
                    defaultValue={server?.username}
                    />
                  {connectionStatus?.status &&  
                    <span className={`absolute p-1 text-sm -bottom-3 ${connectionStatus.success?"text-vekin":"text-red-500"}`}>
                    {connectionStatus?.status}
                    </span> 
                  }

                    <InputWithInnerLabel 
                    label={`${t('device_management.server_setup.password')}`} name="password" placeholder="************" type='password' required={true}
                    defaultValue={server?.password}
                    />

                </div>

                <StepperNav step={step} setStep={setStep} isValid={true}  prev={`< ${t('device_management.server_setup.select_server')}`} next={`${t('device_management.server_setup.test_connection')}`} isNextSubmit={true}/>

            </form>
            }



            {step==3 && type=='huawei-cloud' &&
            <form onSubmit={createNewServer} className='relative'>
                
                <h2 className='text-sm font-semibold text-gray-700 '>3. {t('device_management.server_setup.server_detail_config')}  </h2>

                <LoadingContainer 
                isLoading={false} 
                isError={!stations?.length}
                loadingText={`${t('device_management.server_setup.loading_station')}..`}
                hasData={stations?.length>0} errorText={"Unable to fetch your Huawei Cloud stations. Please close and retry."}>  
                    <div className="relative grid grid-cols-1 gap-4 pb-8 mt-3 md:grid-cols-2">

                    <InputWithInnerLabel 
                        label={`${t('device_management.server_setup.server_name')}`} name="serverName"
                        defaultValue={server?.name}
                        placeholder="Vekin Server" required={true} className="col-span-2"
                        />
                 
                    {stations && stations?.length>0 &&
                        <InputWithInnerLabel 
                        label={`${t('device_management.server_setup.station_code')}`} name="stationCode" placeholder="Vekin" 
                        required={true} 
                        type="select" 
                        className="col-span-2" 
                        optionLabel="station-Code"
                        options={stations} defaultValue={server?.station_code}
                        />
                    }
                    {connectionStatus?.status &&  
                        <span className={`absolute p-1 text-sm -bottom-3 ${connectionStatus.success?"text-vekin":"text-red-500"}`}>
                        {connectionStatus?.status}
                        </span> 
                    }
                    </div>

              
                    <StepperNav step={step} setStep={setStep} 
                    // isValid={true}  prev= {(connectionStatus.success ===undefined || connectionStatus.success) ? "< Test Connection" : "< Select Server type"}
                    // next={'Save Configuration'} 
                    isValid={true}  prev= {(connectionStatus.success ===undefined || connectionStatus.success) ? `${t('device_management.server_setup.test_connection')}` : `${t('device_management.server_setup.select_server')}`}
                    next={`${t('device_management.server_setup.save')}`}
                    isNextSubmit={true}/>
                    
                </LoadingContainer>
            </form>
            }

        </>
       
     );
}
 
export default SetupHuawei;
